var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn button-section",attrs:{"to":{name: 'donateBlood'},"type":"button","id":"btn-schedule"}},[_vm._v(" SCHEDULE APPOINTMENT ")])
}
var staticRenderFns = []

export { render, staticRenderFns }